import {
    Button,
    Collapse,
    Flex,
    NavLink as MantineNavLink,
    Stack,
    Tooltip,
    UnstyledButton,
    rem,
} from '@mantine/core';
import { IconChevronRight, IconGauge } from '@tabler/icons-react';
import { NavLink, useMatch } from 'react-router-dom';

import { NavbarSubItem } from './NavbarSubItem';
import classes from './Navbar.module.css';
import { hasRouteAccess } from '../../../utils/roles';
import { useAuthStore } from '../../../store';
import { useDisclosure } from '@mantine/hooks';
import { useMemo } from 'react';

export function NavbarParentItem({
    icon: Icon,
    label,
    to,
    pattern,
    onClick,
    exact = false,
    subItems = [],
}) {
    const active = useMatch(pattern || to || '', { exact });
    const [opened, { toggle }] = useDisclosure(active);
    const userProfile = useAuthStore((state) => state.userProfile);

    const subLinks = useMemo(() => {
        const ret = subItems
            ?.filter((x) => hasRouteAccess(userProfile, x.routeAccess))
            .map((link, index) => (
                <NavbarSubItem
                    {...link}
                    parentActive={active}
                    key={link.to}
                />
            ));

        return ret && ret.length > 0 ? ret : null;
    }, [subItems, userProfile]);

    return (
        <Stack
            p={0}
            justify='center'
            gap={'xs'}>
            <Stack
                p={0}
                gap={0}>
                <NavLink to={to}>
                    <MantineNavLink
                        py={5}
                        className={classes.link}
                        component={UnstyledButton}
                        label={label}
                        active={active}
                        leftSection={
                            <Icon
                                style={{ width: rem(20), height: rem(20) }}
                                stroke={1.5}
                            />
                        }
                        rightSection={
                            subLinks ? (
                                <Flex
                                    align={'center'}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggle();
                                    }}>
                                    <IconChevronRight
                                        size={16}
                                        stroke={1.5}
                                        style={{
                                            transform: opened
                                                ? 'rotate(90deg)'
                                                : null,
                                        }}
                                    />
                                </Flex>
                            ) : null
                        }
                    />
                </NavLink>
                <Collapse in={opened}>{subLinks}</Collapse>
            </Stack>
        </Stack>
    );
}
